import { Link } from "react-router-dom";
import { COMPANY_LINKEDIN, CALLUM_SOCIALS } from "./socials";

const CallumSocials = () => (
  <div data-testid="footer-callum-socials" className="flex flex-col items-center gap-3 md:justify-self-center">
    <p className="text-sm font-semibold text-white">Here are Callum's socials</p>
    <div className="flex items-center gap-3">
      {CALLUM_SOCIALS.map((s) => (
        <a key={s.key} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={`Callum on ${s.name}`} data-testid={`footer-callum-${s.key}`}
          className={`flex h-11 w-11 items-center justify-center rounded-md ${s.chip} transition-transform duration-300 hover:-translate-y-1`}>
          <s.Icon className="h-5 w-5" />
        </a>
      ))}
    </div>
  </div>
);

const Address = () => (
  <div data-testid="footer-address" className="flex flex-col items-center gap-3 text-sm text-zinc-300 md:items-start">
    <a href="tel:+18149923098" data-testid="footer-phone-link" className="text-white transition-colors hover:text-[#E62314]">Tel: +1 (814) 992-3098</a>
    <p className="font-semibold text-white">Legal Compliance and Business Correspondence.</p>
    <address className="not-italic leading-relaxed">
      Cresway Media<br />30 N Gould St<br />STE R<br />Sheridan, WY 82801<br />USA
    </address>
  </div>
);

export const Footer = () => {
  const { Icon } = COMPANY_LINKEDIN;
  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0A] text-white">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-10 px-5 py-12 text-center sm:px-8 md:items-stretch md:text-left lg:px-12 lg:py-14">
        <div className="flex flex-col items-center gap-8 md:grid md:grid-cols-3 md:items-start">
          <Address />
          <CallumSocials />
          <div className="flex items-center gap-3 md:justify-self-end" data-testid="footer-follow-us">
            <span className="text-sm font-semibold text-white">Follow Us</span>
            <a href={COMPANY_LINKEDIN.href} target="_blank" rel="noopener noreferrer" aria-label="Cresway Media on LinkedIn" data-testid="footer-social-linkedin"
              className={`flex h-11 w-11 items-center justify-center rounded-md ${COMPANY_LINKEDIN.chip} transition-transform duration-300 hover:-translate-y-1`}>
              <Icon className="h-5 w-5" />
            </a>
          </div>
        </div>
        <div className="flex flex-col items-center gap-6 border-t border-white/15 pt-8 md:items-start md:gap-3">
          <div className="flex flex-wrap items-center justify-center gap-3 text-sm md:justify-start">
            <Link to="/about" data-testid="footer-about-link" className="transition-colors hover:text-[#E62314]">About Us</Link>
            <span className="text-zinc-400">|</span>
            <Link to="/privacy" data-testid="footer-privacy-link" className="transition-colors hover:text-[#E62314]">Privacy Policy</Link>
            <span className="text-zinc-400">|</span>
            <Link to="/terms" data-testid="footer-terms-link" className="transition-colors hover:text-[#E62314]">Terms of Service</Link>
            <span className="text-zinc-400">|</span>
            <Link to="/complaints" data-testid="footer-complaints-link" className="transition-colors hover:text-[#E62314]">Make a Complaint</Link>
          </div>
          <p data-testid="footer-copyright" className="text-sm text-zinc-300">Copyright 2026 © Cresway Media LLC. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};
